import { watch } from 'vue'

// Filter key -> row field and dropdown label
export const FILTER_FIELDS = {
  year: { field: 'year', label: 'Years' },
  port: { field: 'port', label: 'Ports' },
  cruise: { field: 'cruiseLine', label: 'Cruise Lines' },
  ship: { field: 'shipName', label: 'Ships' },
  date: { field: 'date', label: 'Dates' },
  time: { field: 'start_time', label: 'Start Times' },
  tour: { field: 'name', label: 'Tours' }
}

export const getUniqueOptions = (data, key, label) => {
  const defaultOption = { value: '', text: `All ${label}` }
  const uniqueValues = [...new Set(data.map(row => row[key]))]
    .filter(Boolean)
    .sort()
    .map(value => ({ value, text: value }))

  return [defaultOption, ...uniqueValues]
}

// Rows matching every active filter, optionally ignoring one filter
export const getFilteredRows = (data, filters, ignoreKey = null) => {
  const activeFilters = Object.entries(FILTER_FIELDS)
    .filter(([key]) => key !== ignoreKey && filters[key])

  return data.filter(row =>
    activeFilters.every(([key, { field }]) => row[field] === filters[key])
  )
}

// Excel-style: each dropdown lists the values left after applying all the other filters
export const getFilterOptions = (data, filters) => {
  return Object.fromEntries(
    Object.entries(FILTER_FIELDS).map(([key, { field, label }]) => [
      key,
      getUniqueOptions(getFilteredRows(data, filters, key), field, label)
    ])
  )
}

// Clear any selection that no longer matches the other filters
export const setupFilterWatchers = (filters, data) => {
  watch(
    () => ({ ...filters.value }),
    () => {
      const options = getFilterOptions(data.value, filters.value)

      Object.keys(FILTER_FIELDS).forEach(key => {
        const value = filters.value[key]
        if (value && !options[key].some(option => option.value === value)) {
          filters.value[key] = ''
        }
      })
    }
  )
}
